import type { Patient } from "@/types/admin-portal/patient";

export function getRegistrationSourceLabel(
	value: Patient["registrationSource"],
) {
	if (!value) return "N/A";

	const data = {
		ADMIN_PANEL: "Admin Panel",
		MOBILE_ANDROID: "Android",
		MOBILE_IOS: "iOS",
		WEB: "Web Portal",
	} as unknown as Record<NonNullable<Patient["registrationSource"]>, string>;

	return data[value];
}
